export const STRIPE_API_KEY = 'pk_test_QVSaZ6zPE1Kg5UwcXEKTlAfK00Tzng9BR5';
